export default __webpack_public_path__ + "static/media/StarIconWhite.830f0535.svg";